import { ref } from 'vue';

import Bag from '@phoenix/components/Bag';
import { showPanel } from '@phoenix/helpers/panel-helper';

export const useAddToBag = () => {
  const isLoading = ref(false);

  const bag = new Bag();
  const addReferencesToBag = async (references: Array) => {
    isLoading.value = true;

    let success = false;

    for (const reference of references) {
      const result = await bag.add(reference, { shouldOpenCartPanel: false });
      if (result) success = true;
    }

    if (success) {
      showPanel('cart-panel');
    }

    isLoading.value = false;
  };

  return {
    isLoading,
    addReferencesToBag,
  };
};
